/// <amd-module name="Build/Admin/Common/ElasticPoolUtils" />
import { format } from "VSS/Core/Util/String";

import { OperatingSystemType } from "DistributedTask/Client/Contracts/TaskAgent";

import { VirtualMachineScaleSet } from "Build/Admin/Common/Client/Contracts/DistributedTask/Azure";

const azurePortalLinkTemplate: string = "https://portal.azure.com/#@{0}/resource{1}";

export function getVMScaleSetOSType(virtualMachineScaleSet: VirtualMachineScaleSet | undefined): OperatingSystemType | undefined {
    if (virtualMachineScaleSet?.properties?.virtualMachineProfile?.osProfile?.windowsConfiguration !== undefined) {
        return OperatingSystemType.Windows;
    }
    else if (virtualMachineScaleSet?.properties?.virtualMachineProfile?.osProfile?.linuxConfiguration !== undefined) {
        return OperatingSystemType.Linux;
    }
    else {
        return undefined;
    }
}

export function getAzurePortalVmssUrl(tenantId: string, virtualMachineScaleSetId: string, subPage?: string | undefined): string {
    const rootUrl: string = format(azurePortalLinkTemplate, tenantId, virtualMachineScaleSetId);
    if (subPage) {
        return format("{0}/{1}", rootUrl, subPage);
    }
    else {
        return rootUrl;
    }
}
